import { type RouteRecordRaw } from 'vue-router'

export const homeRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/HomeView.vue'),
    meta: {
      title: 'home',
    },
    name: 'brand.home',
    path: 'home',
  },
]
